import React, { useContext } from "react";
import { ModalStore } from "./ModalStore";

export const ModalContext = React.createContext<ModalStore>(null);

/**
 * 弹窗管理hook
 */
export function useModalStore() {
    return useContext(ModalContext)!;
}
